import React, { memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { CloseIcon } from '../../common/utilities/closeIcon';
import { translate, forecastRoutes } from '../../../common/translation/translate';
import { WidgetHeader } from '../../common/widgetHeader.jsx';
import { smallMediaQuery, largeMediaQuery } from '../../../common/utilities/sizeHelpers';
import { withScreenSize } from '../../common/utilities/withScreenSize.jsx';

const widgetHeaderStyles = {
    customInlineStyle: isDesktop => ({
        borderBottom: 0,
        fontSize: isDesktop ? 18 : 16,
        lineHeight: 1.25
    })
};

const NationalOutlookScreenHeader = withScreenSize(memo(({ isDesktop }) => {

    return(
        <HeaderContainer>
            <TitleWrapper>
                <WidgetHeader
                    headerText={translate('todaysNationalOutlook')}
                    headerStyle={widgetHeaderStyles.customInlineStyle(isDesktop)}
                />
            </TitleWrapper>
            <IconWrapper>
                <CloseIconContainer href={forecastRoutes.now}>
                    <CloseIcon width={23} height={23} strokeColor='#666' fillColor='#666' />
                </CloseIconContainer>
            </IconWrapper>
        </HeaderContainer>
    );
}));

NationalOutlookScreenHeader.displayName = 'NationalOutlookScreenHeader';

export { NationalOutlookScreenHeader as default };

NationalOutlookScreenHeader.propTypes = {
    returnToPath: PropTypes.string
};

const CloseIconContainer = styled.a`
    cursor: pointer;
    padding: 13px;
    background-color: transparent;
    transition: background-color .15s ease-in-out;
    &:hover{
        background-color: #F0F0F0;
    }
    @media ${largeMediaQuery} {
        padding: 6px;
    }
`;

const HeaderContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    min-height: 26px;
    height: 37px;
    width: 100%;
    @media ${largeMediaQuery} {
        height: 49px;
    }
`;

const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 95%;
    height: 100%;
    @media ${largeMediaQuery} {
        font-size: 18px;
    }
    @media ${smallMediaQuery} {
        width: 87%;
    }
`;

const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    width: 5%;
    background-color: #FFFFFF;
    height: 100%;
    @media ${smallMediaQuery} {
        width: 13%;
    }
`;

